<template>
	<div class="resources">
		<header>
            <Header />
        </header>
		<main>
            <section class="resources-list">
                <div class="container">
                    <div class="row">
                        <!-- 左侧 资源分类 -->
                        <div class="col-xl-3 col-12 resources-wrapper-left">
                            <div class="resources-wrapper-left">
                                <div class="wrapper-left-title">资源分类</div>
                                <!-- tab切换 -->
                                <div class="wrapper-left-tab">
                                    <div class="left-tab-item" :class="{'active':tabNum ==  index+1}" v-for="(item,index) in leftTabList" :key="index" >
                                        <div>{{ item.label }}</div>
                                        <div><i class="el-icon-arrow-right"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 右侧 资源内容 -->
                        <div class="col-xl-9 col-12 resources-wrapper-right">
                            <div class="resources-search-data">
                                <div class="resources-data-title">
                                    <div class="resources-title">{{ resName }}</div>
                                    <div class="resources-total">共 {{ listData.length }} 个资源</div>
                                </div>
                                <div>
                                    <el-input placeholder="请输入资源名称" class="handle-input mb-2" v-model="header.resourceName" clearable></el-input>
                                    <el-button type="primary" icon="el-icon-search" @click="getSearchData">搜索</el-button>
                                    <el-button type="info" @click="reload">重置</el-button>
                                </div>
                                <div class="grid-item-list">
                                    <div class="grid-item-data">
                                        <div class="grid-data-title" >地区:</div>
                                        <div class="grid-data-info" :class="{'active':address == ''}" @click="changeAddress('')">全部</div>
                                        <div class="grid-data-info" :class="{'active':address == '北京'}" @click="changeAddress('北京')">北京</div>
                                        <div class="grid-data-info" :class="{'active':address == '上海'}" @click="changeAddress('上海')">上海</div>
                                        <div class="grid-data-info" :class="{'active':address == '新疆'}" @click="changeAddress('新疆')">新疆</div>
                                        <div class="grid-data-info" :class="{'active':address == '青海'}" @click="changeAddress('青海')">青海</div>
                                        <div class="grid-data-info" :class="{'active':address == '广州'}" @click="changeAddress('广州')">广州</div>
                                        <div class="grid-data-info" :class="{'active':address == '郑州'}" @click="changeAddress('郑州')">郑州</div>
                                        <div class="grid-data-info" :class="{'active':address == '宁夏'}" @click="changeAddress('宁夏')">宁夏</div>
                                    </div>
                                    <div class="grid-item-data">
                                        <div class="grid-data-title">型号:</div>
                                        <div class="grid-data-info" :class="{'active':model == ''}" @click="changeModel('')">全部</div>
                                        <div class="grid-data-info" :class="{'active':model == 'H800'}" @click="changeModel('H800')">H800</div>
                                        <div class="grid-data-info" :class="{'active':model == 'H100'}" @click="changeModel('H100')">H100</div>
                                        <div class="grid-data-info" :class="{'active':model == 'A800'}" @click="changeModel('A800')">A800</div>
                                        <div class="grid-data-info" :class="{'active':model == 'A100'}" @click="changeModel('A100')">A100</div>
                                    </div>
                                </div>
                                <div class="grid-item-list">
                                    <div class="grid-item-data">
                                        <div class="grid-data-title">租金类型:</div>
                                        <div class="grid-data-info" :class="{'active':rentType == ''}" @click="changeRentType('')">全部</div>
                                        <div class="grid-data-info" :class="{'active':rentType == '年租'}" @click="changeRentType('年租')">年租</div>
                                        <div class="grid-data-info" :class="{'active':rentType == '月租'}" @click="changeRentType('月租')">月租</div>
                                    </div>
                                    <div class="grid-item-data">
                                        <div class="grid-data-title">组网类型:</div>
                                        <div class="grid-data-info" :class="{'active':networkType == ''}" @click="changeNetworkType('')">全部</div>
                                        <div class="grid-data-info" :class="{'active':networkType == 'Roce'}" @click="changeNetworkType('Roce')">Roce</div>
                                        <div class="grid-data-info" :class="{'active':networkType == 'IB'}" @click="changeNetworkType('IB')">IB</div>
                                    </div>
                                </div>
                            </div>
                            <div class="container">
                                <div class="row resources-list-data" v-if="tabNum == '1'">
                                    <div class="col-12 col-xl-6 list-data-item" v-for="(item,index) in listData" :key="index" @click="getResourceDetail(item)">
                                        <div class="list-item">
                                            <div class="data-item-title">{{ item.resourceName }}</div>
                                            <div class="row">
                                                <div class="data-item-specs col-6">
                                                    <span>{{ item.address }}</span>
                                                    <span>{{ item.cpuCore}}核 {{ item.memoryCapacity }}G</span>
                                                    <span>{{ item.hardDisk }}GB</span>
                                                    <span>{{ item.model }} 型号</span>
                                                </div>
                                                <div class="data-item-specs col-6">
                                                    <span>{{ item.networking }} 组网</span>
                                                </div>
                                            </div>
                                            
                                            <div class="data-item-desc">{{ item.resourceDesc }}</div>
                                            <div class="data-item-price">
                                                <span v-if="item.monthRent != null"> ¥{{ item.monthRent }} 元/月</span>
                                                <span v-else-if="item.yearRent != null"> ¥{{ item.yearRent }} 元/年</span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="resources-empty" v-if="listData.length == 0">
                                        <el-empty description="暂无数据"></el-empty>
                                    </div>
                                    <div class="pagination">
                                        <el-pagination
                                            background
                                            @current-change="handleCurrentChange"
                                            :current-page="query.pageIndex"
                                            :page-size="query.pageSize"
                                            layout="total, prev, pager, next"
                                            :total="query.total">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>
                </div>
            </section>
            <!-- resources list -->
            
		</main>
        <PayResource 
            :isVisibleDialogResource.sync="isVisibleDialogResource"
            :resId="resId" 
        />
		<!-- <footer><Footer /></footer> -->
	</div>
</template>

<script>
import {
    resourceMarketList
} from '@/api/index'
import Header from '../../components/header.vue';
// import Footer from '../../components/footer.vue';
import PayResource from './payResource.vue';
export default {
  	name: 'Home',
	components: {
		Header,
		// Footer
        PayResource,
	},
	data() {
		return {
            header:{
                resourceName:"", //资源名称
                // model:"", //资源型号
            },
            resName:"GPU 算力服务",
            tabNum:"1",
            leftTabList:[
                {value: 'GPU 算力服务', label: 'GPU 算力服务'},
                // {value: '人工智能', label: '人工智能'},
                // {value: 'CPU 算力服务', label: 'CPU 算力服务'},
                // {value: '存储服务', label: '存储服务'},	
                // {value: '硬件资源', label: '硬件资源'},
                // {value: '云主机', label: '云主机'},
            ],
            address:"",
            model:"",
            rentType:"",
            networkType:"",
            listData:[],
            query:{
                pageIndex:1,
                pageSize:10,
                total:0,
            },
            isVisibleDialogResource:false,
            resId:"",
		};
		
		
	},
	mounted() {
        this.getListData();
	},
    methods:{
        leftTabClick(index,resourceName){
            this.tabNum = index;
            this.resName = resourceName;
            //重置页码和总条数
            this.query.pageIndex = 1;
            this.query.total = 0;
            this.listData = [];
            // 
            if(resourceName == "GPU 算力服务"){
                this.getListData();
            }
        },
        getSearchData(){
            this.query.pageIndex = 1;
            this.getListData();
        },
        async getListData(){
            let param = {
				pageNum:this.query.pageIndex,
				pageSize:this.query.pageSize,
                address:this.address,
				model:this.model, //型号
				networking:this.networkType,//组网
				rentType:this.rentType == '' ? '' : this.rentType == '年租' ? '2' : '1',//1 月租  2 年租  
				resourceName:this.header.resourceName,//资源名称
			}
            const resData = await resourceMarketList(param);
            if(resData.success){
                this.listData = resData.data.records;
                this.query.total = resData.data.total;
            }
        },
        handleCurrentChange(val) {
            this.query.pageIndex = val;
            this.getListData();
        },
        getResourceDetail(item){
            //小屏幕时弹出提示框
			let screenWidth = window.innerWidth;
			let flag = this.$myGlobalMethods(screenWidth)
			if(flag){
				return;
			}
            this.resId = item.id;
            this.isVisibleDialogResource = true;
            // sessionStorage.setItem("resources",JSON.stringify(item));
            // this.$router.push({path:'/products',});
        },
        changeAddress(address){
            this.address = address;
            this.query.pageIndex = 1;
            this.getListData();
        },
        changeModel(model){
            this.model = model;
            this.query.pageIndex = 1;
            this.getListData();
        },
        changeRentType(rentType){
            this.rentType = rentType;
            this.query.pageIndex = 1;
            this.getListData();
        },
        changeNetworkType(networkType){
            this.networkType = networkType;
            this.query.pageIndex = 1;
            this.getListData();
        },
        reload(){
            this.header = {
                resourceName:"", //资源名称
            };
            this.model = "";
            this.rentType = "";
            this.networkType = "";
            this.query.pageIndex = 1;
            this.getListData();
        }
    }
}
</script>
<style lang="scss" scoped>
.resources{
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    width:100%;
    height:100%;
    background-color: #f9fafb;
}
header {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.2rem 0.6rem 0 #0000001a;
    position: sticky;
    top: 0;
    z-index: 99;
}

.resources-list{
    width: 100%;
    height:auto;
    padding:20px 0 20px;
	background-color: #f9fafb;
    // .resources-list-wrapper{
    //     width: 80%;
    //     height:auto;
    //     margin:0 auto;
    //     border-radius: 10px;
    //     display: flex;
    //     justify-content: space-between;
        
    // }
    .resources-wrapper-left{
        // width:15%;
        height:auto;
        max-height:140px;
        margin-top:20px;
        border-radius:5px;
        background-color:#fff;
        
        .wrapper-left-title{
            width: 100%;
            height:40px;
            line-height:40px;
            font-size:15px;
            box-sizing: border-box;
            padding-left:10px;
            letter-spacing: 1px;
            border-bottom:1px solid #e5e7eb;
        }
        .wrapper-left-tab{
            width:100%;
            height:auto;
            // margin:10px 0;
            box-sizing:border-box;
            padding:10px 10px;
            .left-tab-item{
                width: 100%;
                height:40px;
                line-height:40px;
                box-sizing: border-box;
                padding:0 10px;
                font-size:15px;
                display: flex;
                justify-content: space-between;
            }
            .left-tab-item:hover{
                color:#106eea;
                cursor: pointer;
                background-color: #f9fafb;
            }
            .left-tab-item.active{
                color:#409EFF;
                background-color: #dbeafe;
            }
        }
    }

    .resources-wrapper-right{
        // width:83%;
        height:auto;
        margin-top:20px;
        .resources-search-data{
            width:100%;
            height:auto;
            background-color:#fff;
            border-radius:5px;
            box-sizing:border-box;
            padding:10px 10px;
            .resources-data-title{
                width:100%;
                height:40px;
                line-height:40px;
                margin-bottom:10px;
                display: flex;
                justify-content: space-between;
                .resources-title{
                    font-size:22px;
                    color:#333;
                }
                .resources-total{
                    font-size:12px;
                    color:#606266;	
                }
            }
            .grid-item-list{
                width:100%;
                height:auto;
                margin-top:0.5rem;
                display: flex;
                gap:0 20px;
                flex-wrap: wrap;
                justify-content: flex-start;
                .grid-item-data{
                    // width:auto;
                    // height:auto;
                    // background-color:#f0f;
                    .grid-data-title{
                        margin:10px 0;
                        // letter-spacing:2px;
                        // font-family: '楷体';
                        color:#333;
                    }
                    .grid-data-info{
                        display:inline-block;
                        height: 30px;
                        margin-right:10px;
                        margin-bottom:10px;
                        padding:0 8px;
                        line-height:30px;
                        border-radius:5px;
                        border: 1px solid #e5e7eb;
                        font-size:12px;
                        cursor:pointer;
                    }
                    .grid-data-info.active{
                        color:#fff;
                        background-color:#409EFF;
                    }
                }
            }
        }
        .resources-list-data{
            // width:100%;
            height:auto;
            margin-top:20px;
            // margin-left:2px;
            // box-sizing:border-box;
            // padding:10px 0;
            // display:flex;
            // flex-wrap: wrap;
            // justify-content: space-between;
            cursor:pointer;
            // background-color: #f00;
            .list-data-item{
                // width:49%;
                // height:auto;
                // margin:10px 0;
                box-sizing: border-box;
                padding:0 10px;
                // border-radius:5px;
                // background-color:#f00;
                .list-item{
                    margin-bottom:20px;
                    // min-height:auto;
                    box-sizing: border-box;
                    padding:10px 10px;
                    border-radius:10px;
                    background-color:#fff;
                    .data-item-title{
                        font-size:1rem;
                        font-weight:600;
                        color:#333;
                        margin-bottom:10px;
                    }
                    .data-item-specs{
                        width:100%;
                        height:30px;
                        margin-bottom:10px;
                        span{
                            font-size:12px;
                            margin-right:10px;
                            padding:5px 8px;
                            color:#0066ff;
                            border-radius:5px;
                            background-color: #dbeafe;
                        }
                    }
                    .data-item-desc{
                        font-size:14px;
                        color:#606266;
                        margin-bottom:10px;
                        display: -webkit-box;
                        -webkit-line-clamp:3; 
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .data-item-price{
                        font-size:0.8rem;
                        font-weight:600;
                        color:#0066ff;

                    }
                }
                
            }
        }
        .resources-empty{
            width:100%;
            height:auto;
            min-height:300px;
            margin-top:10px;
            background-color:#fff;
        }
        // .pagination{
        //     margin:20px 0;
        // }
    }
}
</style>

<style  scoped>
.handle-input{
    width:300px;
    margin-right:10px;
}
</style>
